import React, { useContext, useEffect } from "react";
// import PropTypes from "prop-types";
import styles from "./style/PublishTab.module.css";
import { TabTitle } from "@components";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createCourseAction } from "@redux/actions";
import { useNavigate } from "react-router-dom";
import {
  createCourseActions,
  editingCourseActions,
  updateCourseAction,
} from "@redux/modules/course/slices";
import { CourseContext } from "..";

const PublishTab = () => {
  const { step, setStep, isUpdate, autoSave, setAutoSave } =
    useContext(CourseContext);
  const { editingCourse, createCourse, updateCourse } = useSelector(
    (state) => state.course
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRedirectUpdateSuccess = () => {
    navigate("/instructor-courses", {
      replace: true,
    });
  };
  const handleRedirectCreateSuccess = () => {
    navigate("/create-course-success", {
      replace: true,
      state: { courseId: createCourse.data.id },
    });
  };
  const handleSubmitCourse = async () => {
    const isActive = editingCourse.isActive;
    await dispatch(editingCourseActions.publishCourse());

    dispatch(
      updateCourseAction({
        redirectUpdate: handleRedirectUpdateSuccess,
        redirectCreate: handleRedirectCreateSuccess,
        isPublish: true,
        isActive: isActive,
      })
    );
  };

  useEffect(() => {
    // if (createCourse?.isSuccess) {
    //   navigate("/create-course-success", {
    //     replace: true,
    //     state: { courseId: createCourse.data.id },
    //   });
    // } else if (updateCourse?.isSuccess) {
    //   navigate("/instructor-courses", {
    //     replace: true,
    //   });
    // }
    // return () => {
    //   dispatch(createCourseActions.reset());
    // };
  }, [createCourse, updateCourse]);

  const handleSaveChange = async () => {
    dispatch(updateCourseAction());
  };

  return (
    <div className="position-relative">
      <div>
        <TabTitle
          onSave={handleSaveChange}
          isAutoSave={autoSave}
          setAutoSave={setAutoSave}
        >
          <i className="bi bi-upload mr-2"></i>Submit
        </TabTitle>
        <div className="bg-white text-center p-5">
          <i className="bi bi-pencil-square fs-3"></i>
          <p className="mt-3">
            Your course is ready to publish now. Students cannot view, purchase
            or enroll in this course. After you submit your confirmation, it
            will take some time for the system to moderate your content, then
            your course will be published to students.
          </p>
        </div>
        <div className=" d-flex justify-content-between mt-5">
          <Button
            onClick={() => {
              setStep(step - 1);
            }}
            disabled={step == 1 ? true : false}
          >
            Prev
          </Button>

          <Button onClick={handleSubmitCourse}>
            {isUpdate ? "Save changes" : "Submit for review"}
          </Button>
        </div>
      </div>
      {createCourse.processing || updateCourse.processing ? (
        <div className={styles.spinnerMask}>
          <div className="text-center">
            <Spinner animation="border" />
            <div className="text-danger">Loading...</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

/* required: display name */
PublishTab.displayName = "PublishTab";

/* required: props types */
PublishTab.propTypes = {};

/* required: default props */
PublishTab.defaultProps = {};

export { PublishTab };
